import {postData} from "@/utils/sendData";
import {API} from "@/api/API";
import {deserializedData} from "@/utils/deserializedData";
import JSONAPISerializer from "jsonapi-serializer/lib/serializer";

export const GeneralMethods = {
    getEventResource: async (eventType, eventId) => {
        let response, result, parsedObj;
        try {
            response = await postData(null, API.getEventParams.path(eventType, eventId), API.getEventParams.method)
            if (response.data.data) {
                result = await deserializedData(response.data)
                parsedObj = {
                    eventAfishaId: result.event_afisha ? result.event_afisha.id : null,
                    afishaImage: result.event_afisha ? result.event_afisha.image : null,
                    title: result.title,
                    type: result.content_type_text,
                    status: result.state_name,
                    statusCode: result.state,
                    category: result.category_id,
                    age: result.recommended_age,
                    tags: result.tags,
                    isHidden: result.is_hidden,
                    dates: result.dates,
                    datesTimezone: result.dates_timezone,
                    dateStart: result.datetime_start,
                    utc: result.timezone.utc,
                    timezone: result.timezone.timezone,
                    prices: result.reg_prices,
                    overallSum: result.overall_sum,
                    expectedProfit: result.expected_profit,
                    overallTickets: result.overall_tickets,
                    address: result.event_address ? [result.event_city_name, result.event_address].join(', ') : null,
                    access: result.access,
                    landingUrl: result.landing_url,
                    checkUrl: result.check_url,
                    cabinetUrl: result.cabinet_url,
                    releasePeriodLabel: result.release_period_label,
                    releasePeriod: result.release_period,
                    previewUrl: result.preview_url,
                    isWidget: result.is_widget,
                    commissionRate: result.commission_rate,
                    commissionRates: result.commission_rates,
                    eventSlug: result.event_slug,
                }
            }
        } catch (err) {
            console.log(err)
        }
        return parsedObj
    },
    getTags: async () => {
        let res = await postData(null, API.getTags.path(), API.getTags.method)
        return await deserializedData(res.data)
    },
    getEventAfisha: async (eventType, eventId) => {
        try {
            let response = await postData(null, API.getEventAfisha.path(eventType, eventId), API.getEventAfisha.method)
            return await deserializedData(response.data)
        } catch (err) {
            console.log(err)
        }
    },
    getUserPermissions: async (eventType, eventId) => {
        let response;
        try {
            response = await postData(null, API.eventUserPermissions.path(eventType, eventId), API.eventUserPermissions.method)
        } catch (err) {
            console.log(err)
        }
        return response
    },
    getConstants: () => {
        return postData(null, API.getEventsConstants.path, API.getEventsConstants.method);
    },
    getUploadImageUrl: (data, eventId) => {
        return postData(data, API.getEventUploadImgUrl.path(eventId), API.getEventUploadImgUrl.method)
    },
    createTag: async (title) => {
        let serialized = new JSONAPISerializer('tags', {
            keyForAttribute: 'underscore_case',
            attributes: ['name'],
        }).serialize({name: title});

        let res = await postData(serialized, API.createTag.path(), API.createTag.method)
        return await deserializedData(res.data)
    },
    patchEventParams: async (eventType, eventId, data) => {
        let response, serialized, tags;

        tags = data.tags ? {
            tags: data.tags.length > 0 ? data.tags.map(tag => ({id: tag.id})) : []
        } : undefined

        serialized = new JSONAPISerializer(eventType, {
            keyForAttribute: 'underscore_case',
            attributes: ['event_title', 'is_hidden', 'category_id', 'recommended_age', 'is_widget', 'tags', 'theme_form'],
            tags: {
                ref: 'id',
                relationshipType: 'hasMany',
                type: 'tags'
            }
        }).serialize({
            id: eventId,
            event_title: data.title,
            is_hidden: data.isHidden,
            category_id: data.category,
            recommended_age: data.age,
            is_widget: data.isWidget,
            theme_form: data.themeForm,
            ...tags
        });

        try {
            response = await postData(serialized, API.patchEventParams.path(eventType, eventId), API.patchEventParams.method)
            return response
        } catch (err) {
            console.log(err)
        }
    },
    publishEvent: (eventType, eventId, releasePeriod) => {
        return postData(releasePeriod, API.publishEvent.path(eventType, eventId), API.publishEvent.method)
    },
    cancelEvent: (eventId) => {
        return postData({}, API.cancelEvent.path(eventId), API.cancelEvent.method)
    },
    copyEvent: (eventType, eventId, dateStart) => {
        return postData(dateStart, API.copyEvent.path(eventType, eventId), API.copyEvent.method)
    },
    archiveEvent: (eventType, eventId) => {
        return postData({}, API.archiveEvent.path(eventType, eventId), API.archiveEvent.method)
    },
    reportUploadImg: (fileId, eventId) => {
        return postData({}, API.reportSuccessUploadImg.path(fileId, eventId), API.reportSuccessUploadImg.method)
    },
    updateEventSlug: (slugId, slug) => {
        let data = {}
        return postData(data, API.updateEventSlug.path(slugId), API.updateEventSlug.method)
    }
}
